import { render } from "./SingleApplication.vue?vue&type=template&id=132e128c&scoped=true&ts=true"
import script from "./SingleApplication.vue?vue&type=script&lang=ts"
export * from "./SingleApplication.vue?vue&type=script&lang=ts"

import "./SingleApplication.vue?vue&type=style&index=0&id=132e128c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132e128c"]])

export default __exports__